import { h } from "preact";

import i18n from "../../i18n.js";
import { replaceVariables } from "../../config/germanVariables.js";

import Button from "../Button.jsx";
import List from "../List.jsx";
import ListItem from "../ListItem.jsx";
import WhitepaperTeaser from "../WhitepaperTeaser.jsx";

export default {
  visa_check: ({ onRestart }) => {
    return (
      <section class="task-page">
        <h1 class="task-page__headline">TODO</h1>

        <p class="task-page__content"></p>

        <div class="task-page__buttons">
          <Button onClick={onRestart}>BACK</Button>
        </div>
      </section>
    );
  },
  visa_check_visa_free: ({ onNext, onRestart }) => {
    return (
      <section class="task-page">
        <h1 class="task-page__headline">
          {i18n.t("pages.common.result_title")}
        </h1>

        <div class="task-page__content">
          <div class="task-page__illustation">
            <img src="/images/product_header_visa.svg" />
          </div>

          <List class="mb-32 mt-32">
            <ListItem overline="Visa exemption">
              Based on the information provided, you do not require a visa to
              enter the Federal Republic of Germany.
            </ListItem>
          </List>

          <WhitepaperTeaser
            class="mt-48 mb-64"
            title="Visa"
            description={i18n.t("whitepaperTeaser.visa")}
            whitepaperId="get-a-visa-for-germany"
          />
        </div>

        <div class="task-page__buttons">
          <Button secondary onClick={onNext}>
            {i18n.t("actions.done")}
          </Button>
          <Button text onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },
  visa_check_blue_card: ({ onNext, onRestart, product, ...props }) => {
    let text = "";
    switch (product.id) {
      case "§18g_blue_card":
        text =
          "Qualified academic professionals in a position commensurate with their qualifications and a designated minimum remuneration of [Mindestgehaltsgrenze] per annum can apply for a Blue Card EU (§ 18g para 1 sentence 1).";
        break;
      case "§18g_blue_card_1_2_1":
        text =
          "Physicians, engineers, natural scientists, mathematicians, and IT specialists can apply for a Blue Card EU (§ 18g para 1, sentence 2 No. 1) if their annual salary meets or exceeds [Mindestgehaltsgrenze Mangelberuf].";
        break;
      case "§18g_blue_card_1_2_2":
        text =
          "Young professionals who have obtained any academic degree within the last three years can apply for a Blue Card EU (§ 18g para 1, sentence 2 No. 2) if their annual salary meets or exceeds [Mindestgehaltsgrenze Mangelberuf].";
        break;
      case "§18g_blue_card_1_5":
        text =
          "Skilled workers who have completed a 3-year tertiary education program can apply for a Blue Card EU (§ 18g para 1, sentence 5) if their yearly salary reaches at least [Mindestgehaltsgrenze Mangelberuf].";
        break;
      case "§18g_blue_card_2":
        text =
          "Skilled IT workers with at least three years of work experience within the last seven years can apply for the Blue Card EU (§ 18g para 2), even without a formal academic qualification. The annual salary must meet or exceed [Mindestgehaltsgrenze Mangelberuf].";
        break;
    }

    return (
      <section class="task-page">
        <h1 class="task-page__headline">German national visa</h1>

        <div class="task-page__content">
          <p class="mt-0">EU Blue Card</p>
          <div class="task-page__illustation">
            <img src="/images/product_header_visa.svg" />
          </div>

          <p>{replaceVariables(text)}</p>

          <List class="mb-32 mt-32">
            <ListItem overline="Validity">Maximum of 90 days.</ListItem>
            <ListItem overline="Employment">
              Entitling the holder to take up gainful employment.
            </ListItem>
            <ListItem overline="Travel restrictions">
              Move freely in the Schengen area for up to three months in any six
              months period.
            </ListItem>
          </List>

          <h2 class="t-h6 t-h6--margin">Notice</h2>

          <List class="mb-32">
            <ListItem overline="Visa processing time">
              About six to eight weeks.
            </ListItem>
            <ListItem overline="Visa fee">
              {replaceVariables(
                "Adults [National Visa Fee] / Minors [Reduced National Visa Fee]"
              )}
            </ListItem>
            <ListItem overline="Legal basis">
              {i18n.t(`products.${product.id}.legal_basis`)}
            </ListItem>
          </List>

          <WhitepaperTeaser
            class="mt-48 mb-64"
            title="Visa"
            description={i18n.t("whitepaperTeaser.visa")}
            whitepaperId="get-a-visa-for-germany"
          />
        </div>

        <div class="task-page__buttons">
          <Button secondary onClick={onNext}>
            {i18n.t("actions.done")}
          </Button>
          <Button text onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },
  visa_check_occupation: ({ onNext, onRestart, product }) => {
    return (
      <section class="task-page">
        <h1 class="task-page__headline">German national visa</h1>

        <div class="task-page__content">
          <p class="mt-0">Employment visa</p>
          <div class="task-page__illustation">
            <img src="/images/product_header_visa.svg" />
          </div>

          <p>
            If you already have a recognized qualification such as a university
            degree or vocational qualification, and you already have a contract,
            you can apply for a work visa.
          </p>

          <List class="mb-32 mt-32">
            <ListItem overline="Validity">Maximum of 90 days.</ListItem>
            <ListItem overline="Employment">
              Entitling the holder to take up gainful employment.
            </ListItem>
            <ListItem overline="Travel restrictions">
              Move freely in the Schengen area for up to three months in any six
              months period.
            </ListItem>
          </List>

          <h2 class="t-h6 t-h6--margin">Notice</h2>

          <List class="mb-32">
            <ListItem overline="Visa processing time">
              About six to eight weeks.
            </ListItem>
            <ListItem overline="Visa fee">
              {replaceVariables(
                "Adults [National Visa Fee] / Minors [Reduced National Visa Fee]"
              )}
            </ListItem>
            <ListItem overline="Legal basis">
              {i18n.t(`products.${product.id}.legal_basis`)}
            </ListItem>
          </List>

          <WhitepaperTeaser
            class="mt-48 mb-64"
            title="Visa"
            description={i18n.t("whitepaperTeaser.visa")}
            whitepaperId="get-a-visa-for-germany"
          />
        </div>

        <div class="task-page__buttons">
          <Button secondary onClick={onNext}>
            {i18n.t("actions.done")}
          </Button>
          <Button text onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },
  visa_check_ict_diverse: ({ onNext, onRestart, product }) => {
    return (
      <section class="task-page">
        <h1 class="task-page__headline">German national visa</h1>

        <div class="task-page__content">
          <p class="mt-0">Employment visa</p>
          <div class="task-page__illustation">
            <img src="/images/product_header_visa.svg" />
          </div>

          <p>
            {replaceVariables(`
            To work in the IT sector in Germany, you do not need to have a
            recognized degree if you have been working in the IT sector elsewhere
            for at least three years within the last seven years. You need a job
            offer in Germany that pays you [Mindestgehaltsgrenze IT-Fachkräfte ohne Ausbildung]
            before taxes or more.
          `)}
          </p>
          <p>
            {replaceVariables(`
            For physicians, engineers, natural scientists, mathematicians and
            IT-specialists, a yearly salary of [Mindestgehaltsgrenze Mangelberuf]
            is sufficient.
          `)}
          </p>

          <List class="mb-32 mt-32">
            <ListItem overline="Validity">Maximum of 90 days.</ListItem>
            <ListItem overline="Employment">
              Entitling the holder to take up gainful employment.
            </ListItem>
            <ListItem overline="Travel restrictions">
              Move freely in the Schengen area for up to three months in any six
              months period.
            </ListItem>
          </List>

          <h2 class="t-h6 t-h6--margin">Notice</h2>

          <List class="mb-32">
            <ListItem overline="Visa processing time">
              About six to eight weeks.
            </ListItem>
            <ListItem overline="Visa fee">
              {replaceVariables(
                "Adults [National Visa Fee] / Minors [Reduced National Visa Fee]"
              )}
            </ListItem>
            <ListItem overline="Legal basis">
              {i18n.t(`products.${product.id}.legal_basis`)}
            </ListItem>
          </List>

          <WhitepaperTeaser
            class="mt-48 mb-64"
            title="Visa"
            description={i18n.t("whitepaperTeaser.visa")}
            whitepaperId="get-a-visa-for-germany"
          />
        </div>

        <div class="task-page__buttons">
          <Button secondary onClick={onNext}>
            {i18n.t("actions.done")}
          </Button>
          <Button text onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },
  visa_check_study_preparing_language_course: ({
    onNext,
    onRestart,
    product,
  }) => {
    return (
      <section class="task-page">
        <h1 class="task-page__headline">German national visa</h1>

        <div class="task-page__content">
          <p class="mt-0">Recognition of foreign professional qualifications</p>
          <div class="task-page__illustation">
            <img src="/images/product_header_visa.svg" />
          </div>

          <p>
            If your qualification is not fully recognized, you can get the extra
            qualifications in Germany while already working. Once you have
            completed your additional training, you can get your qualification
            fully recognized and apply for a long-term residence permit to work.
          </p>

          <List class="mb-32 mt-32">
            <ListItem overline="Validity">Maximum of 90 days.</ListItem>
            <ListItem overline="Employment">
              Entitling the holder to take up gainful employment.
            </ListItem>
            <ListItem overline="Travel restrictions">
              Move freely in the Schengen area for up to three months in any six
              months period.
            </ListItem>
          </List>

          <h2 class="t-h6 t-h6--margin">Notice</h2>

          <List class="mb-32">
            <ListItem overline="Visa processing time">
              About six to eight weeks.
            </ListItem>
            <ListItem overline="Visa fee">
              {replaceVariables(
                "Adults [National Visa Fee] / Minors [Reduced National Visa Fee]"
              )}
            </ListItem>
            <ListItem overline="Legal basis">
              {i18n.t(`products.${product.id}.legal_basis`)}
            </ListItem>
          </List>

          <WhitepaperTeaser
            class="mt-48 mb-64"
            title="Visa"
            description={i18n.t("whitepaperTeaser.visa")}
            whitepaperId="get-a-visa-for-germany"
          />
        </div>

        <div class="task-page__buttons">
          <Button secondary onClick={onNext}>
            {i18n.t("actions.done")}
          </Button>
          <Button text onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },
  visa_check_job_hunting_specialist: ({ onNext, onRestart, product }) => {
    return (
      <section class="task-page">
        <h1 class="task-page__headline">German national visa</h1>

        <div class="task-page__content">
          <p class="mt-0">Job seeker</p>
          <div class="task-page__illustation">
            <img src="/images/product_header_visa.svg" />
          </div>

          <p>
            With a job seeker visa, you can stay for up to six months in Germany
            to find a job corresponding to your qualification. Once you find an
            adequate job, you can get a residence permit.
          </p>

          <List class="mb-32 mt-32">
            <ListItem overline="Validity">Maximum of 180 days.</ListItem>
            <ListItem overline="Employment">
              A job seeker visa does not entitle the holder to take up gainful
              employment.
            </ListItem>
            <ListItem overline="Travel restrictions">
              Move freely in the Schengen area for up to three months in any six
              months period.
            </ListItem>
          </List>

          <h2 class="t-h6 t-h6--margin">Notice</h2>

          <List class="mb-32">
            <ListItem overline="Visa processing time">
              About six to eight weeks.
            </ListItem>
            <ListItem overline="Visa fee">
              {replaceVariables(
                "Adults [National Visa Fee] / Minors [Reduced National Visa Fee]"
              )}
            </ListItem>
            <ListItem overline="Legal basis">
              {i18n.t(`products.${product.id}.legal_basis`)}
            </ListItem>
          </List>

          <WhitepaperTeaser
            class="mt-48 mb-64"
            title="Visa"
            description={i18n.t("whitepaperTeaser.visa")}
            whitepaperId="get-a-visa-for-germany"
          />
        </div>

        <div class="task-page__buttons">
          <Button secondary onClick={onNext}>
            {i18n.t("actions.done")}
          </Button>
          <Button text onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },
  visa_check_not_mvp: ({ onNext, onRestart }) => {
    return (
      <section class="task-page">
        <h1 class="task-page__headline">
          {i18n.t("pages.common.result_title")}
        </h1>

        <div class="task-page__content">
          <div class="task-page__illustation">
            <img src="/images/product_header_visa.svg" />
          </div>

          <List class="mb-32 mt-32">
            <ListItem overline="Visa">
              We are hard-working to be able to support your visa type soon as
              well.
            </ListItem>
          </List>

          <WhitepaperTeaser
            class="mt-48 mb-64"
            title="Visa"
            description={i18n.t("whitepaperTeaser.visa")}
            whitepaperId="get-a-visa-for-germany"
          />
        </div>

        <div class="task-page__buttons">
          <Button secondary onClick={onNext}>
            {i18n.t("actions.done")}
          </Button>
          <Button text onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },
};
